import { render, staticRenderFns } from "./BackgroundHostingCreate.vue?vue&type=template&id=ceead752&"
import script from "./BackgroundHostingCreate.vue?vue&type=script&lang=js&"
export * from "./BackgroundHostingCreate.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundHostingCreate.vue?vue&type=style&index=0&id=ceead752&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports